const isEnabled = (value) => value === "true";

export const ENABLE_TRADING = isEnabled(process.env.REACT_APP_ENABLE_TRADING);
export const ENABLE_MARKET_DATA = isEnabled(
  process.env.REACT_APP_ENABLE_MARKET_DATA,
);
export const ENABLE_ALBERTA_ENERGY_DAILY = isEnabled(
  process.env.REACT_APP_ENABLE_ALBERTA_ENERGY_DAILY,
);
export const ENABLE_ALBERTA_ENVIRONMENTAL = isEnabled(
  process.env.REACT_APP_ENABLE_ALBERTA_ENVIRONMENTAL,
);
export const ENABLE_BC_ENVIRONMENTAL = isEnabled(
  process.env.REACT_APP_ENABLE_BC_ENVIRONMENTAL,
);
